import React, { Component } from 'react';
// import * as firebase from 'firebase';
import firebase from '../helper/firebase';

import validator from 'email-validator';

import {
	AppBar,
	Button,
	Card,
	CardActions,
	CardContent,
	// CircularProgress,
	TextField,
	Typography
} from 'material-ui';
import Tabs, { Tab } from 'material-ui/Tabs';

import Fade from 'material-ui/transitions/Fade';

import Snack from '../components/Snack';

import '../styles/JoinCard.css';

import { ReactGoogleAnalytics } from '../helper/functions';

// const style = {
//   card:{
//     maxWidth: '780px',
//     minWidth: '300px',
//     overflow: 'visible',
//     position: 'relative',
//     border: '1px solid rgba(0,0,0,0.07)',
//     boxShadow: '0 1px 5px rgba(0,0,0,0.05)',
//     width: '100%',
//     margin: '0',
//   },
//   row:{
//     display: 'flex',
//     flexWrap: 'wrap',
//     margin:'21px 0'
//   },
//   input:{
//     minWidth:'160px',
//     flexGrow: '1',
//     margin:'10px',
//   },
//   forgot:{
//     cursor:'pointer',
//   }
// }

export default class JoinCard extends Component {
	constructor(props) {
		super(props);

		this.state = {
			loggedIn: false,
			authLoading: true,
			loading: true,
			email: '',
			password: '',
			fullName: '',
			value: this.props.tab ? this.props.tab : 'signIn'
		};
	}

	componentDidMount() {
		firebase.auth().onAuthStateChanged(user => {
			if (user) {
				this.setState({
					loggedIn: true,
					authLoading: false,
					loading: false
				});
			} else {
				this.setState({
					loggedIn: false,
					authLoading: false,
					loading: false,
					email: '',
					password: '',
					fullName: '',
					value: this.props.tab ? this.props.tab : 'signIn'
				});
			}
		});
	}

	handleChange = name => event => {
		this.setState({
			[name]: event.target.value,
			emailError: false,
			passwordError: false,
			fullNameError: false
		});
		if (name === 'email') {
			let status = validator.validate(event.target.value);
			this.setState({ emailError: !status });
		}
	};

	closeSnack = () => {
		this.setState({ snackStatus: false, snackMessage: '' });
	};

	handleTabChange = (event, value) => {
		this.setState({
			value,
			emailError: false,
			passwordError: false,
			displayNameError: false
		});
	};

	validate = path => {
		this.setState({ signing: true });
		const { email, password, fullName } = this.state;
		if (email.length < 1 || this.state.emailError) {
			this.setState({
				signing: false,
				emailError: true,
				snackStatus: true,
				snackMessage: 'Error, please complete all fields.'
			});
			return;
		}
		if ((path === 'signUp' || path === 'signIn') && password.length < 5) {
			this.setState({
				signing: false,
				passwordError: true,
				snackStatus: true,
				snackMessage: 'Error, please complete all fields.'
			});
			return;
		}
		if (path === 'signUp' && fullName.length < 5) {
			this.setState({
				signing: false,
				fullNameError: true,
				snackStatus: true,
				snackMessage: 'Error, please complete all fields.'
			});
			return;
		}
		if (path === 'signUp') {
			this.signUp();
		}
		if (path === 'signIn') {
			this.signIn();
		}
		if (path === 'help') {
			this.sendPasswordResetEmail();
		}
	};

	signUp = () => {
		const { email, password, fullName } = this.state;
		const body = {
			email,
			password,
			displayName: fullName
		};
		const options = {
			method: 'post',
			body: JSON.stringify(body)
		};
		const url = `https://us-central1-talent-7d36f.cloudfunctions.net/signUpNewUser`;
		fetch(url, options)
			.then(res => {
				//if result comes back with 200, sign user in;
				if (res.status === 200) {
					ReactGoogleAnalytics('Auth', 'Signup', null, null, null);
					this.signIn();
					return;
				} else {
					//if result isn't 200, check reason for error
					this.setState({
						signing: false,
						snackStatus: true,
						snackMessage: `Error: please try again.`
					});
				}
			})
			.catch(err => {
				console.log(err);
				this.setState({
					signing: false,
					emailError: true,
					passwordError: true,
					snackStatus: true,
					snackMessage: 'Error: Please check your details and try again.'
				});
			});
	};

	signIn = () => {
		const { email, password } = this.state;
		firebase
			.auth()
			.signInWithEmailAndPassword(email, password)
			.then(user => {
				console.log('user is ', user);
				this.setState({
					signing: false
				});
				ReactGoogleAnalytics('Auth', 'Login', null, null, null);
			})
			.catch(error => {
				console.log(error);
				// return error;
				this.setState({
					signing: false,
					snackStatus: true,
					snackMessage: `Error: ${error}`
				});
			});
	};

	sendPasswordResetEmail = () => {
		const { email } = this.state;
		const actionCodeSettings = {
			url: window.location.href
		};
		firebase
			.auth()
			.sendPasswordResetEmail(email, actionCodeSettings)
			.then(() => {
				this.setState({
					signing: false,
					snackStatus: true,
					snackMessage: 'Password Reset Email Sent.'
				});
				ReactGoogleAnalytics('Auth', 'Reset', null, null, null);
			})
			.catch(error => {
				this.setState({
					signing: false,
					snackStatus: true,
					snackMessage: `Error: ${error}`
				});
			});
	};

	renderSignInWithEmailBtn = () => {
		return null;
		//auth().sendSignInLinkToEmail is not working
		// return (
		//     <Button
		//       className='cardActionsBtn'
		//       raised
		//       disabled={this.state.signing}
		//       color='primary'
		//       onClick={this.signInWithEmail}
		//     >
		//       Sign In Via Email
		//     </Button>
		// )
	};

	signInWithEmail = () => {
		this.setState({ signing: true });
		const { email } = this.state;
		if (email.length < 1 || this.state.emailError) {
			this.setState({
				signing: false,
				emailError: true,
				snackStatus: true,
				snackMessage: 'Error, please complete all fields.'
			});
			return;
		}
		let actionCodeSettings = {
			url: window.location.href,
			handleCodeInApp: true
		};
		firebase
			.auth()
			.sendSignInLinkToEmail(email, actionCodeSettings)
			.then(res => {
				console.log(res);
				this.setState({
					signing: false,
					snackStatus: true,
					snackMessage:
						'A Magin Sign In Link has been sent to your email address if it is registered.'
				});
			})
			.catch(err => {
				console.log(err);
				this.setState({
					signing: false,
					snackStatus: true,
					snackMessage:
						'A Magin Sign In Link has been sent to your email address if it is registered.'
				});
			});
	};

	closeSnack = () => {
		this.setState({ snackStatus: false, snackMessage: '' });
	};

	render() {
		console.log(window.location);
		return (
			<div>
				<Fade in={true}>
					<Card className="joinCard" key="joinCard">
						{!!!this.props.hideHeader && (
							<AppBar
								className="joinCardHeader"
								position="static"
								color="default"
							>
								<Tabs
									centered
									fullWidth
									value={this.state.value}
									onChange={this.handleTabChange}
									indicatorColor="primary"
									textColor="primary"
								>
									<Tab value="signUp" label="Sign Up" />
									<Tab value="signIn" label="Sign In" />
									<Tab value="help" label="Help" />
								</Tabs>
							</AppBar>
						)}
						{this.state.value === 'signUp' && (
							<CardContent>
								<form noValidate autoComplete="off">
									<div className="row">
										<TextField
											className="input"
											id="email"
											label="Email"
											placeholder="Email..."
											error={this.state.emailError}
											required
											value={this.state.email}
											onChange={this.handleChange('email')}
											margin="normal"
										/>
										<TextField
											className="input"
											id="password"
											type="password"
											label="Password"
											placeholder="Password..."
											error={this.state.passwordError}
											required
											value={this.state.password}
											onChange={this.handleChange('password')}
											margin="normal"
										/>
									</div>
									<div className="row">
										<TextField
											fullWidth
											className="input"
											id="fullName"
											label="Full Name"
											placeholder="Full Name..."
											error={this.state.fullNameError}
											required
											value={this.state.fullName}
											onChange={this.handleChange('fullName')}
											margin="normal"
										/>
									</div>
								</form>
							</CardContent>
						)}
						{this.state.value === 'signIn' && (
							<CardContent>
								<form noValidate autoComplete="off">
									<div className="row">
										<TextField
											className="input"
											id="email"
											label="Email"
											placeholder="Email..."
											error={this.state.emailError}
											required
											value={this.state.email}
											onChange={this.handleChange('email')}
											margin="normal"
										/>
										<TextField
											className="input"
											id="password"
											type="password"
											label="Password"
											placeholder="Password..."
											error={this.state.passwordError}
											required
											value={this.state.password}
											onChange={this.handleChange('password')}
											margin="normal"
										/>
									</div>
								</form>
							</CardContent>
						)}
						{this.state.value === 'help' && (
							<CardContent>
								<form noValidate autoComplete="off">
									<div className="row">
										<TextField
											className="input"
											id="email"
											label="Email"
											placeholder="Email..."
											error={this.state.emailError}
											required
											value={this.state.email}
											onChange={this.handleChange('email')}
											margin="normal"
										/>
									</div>
								</form>
							</CardContent>
						)}
						<CardActions className="cardActions">
							{this.state.value === 'signUp' && (
								<Button
									className="cardActionsBtn"
									raised
									disabled={this.state.signing}
									color="primary"
									onClick={() => {
										this.validate('signUp');
									}}
								>
									{this.state.signing ? 'Signing Up' : 'Sign Up'}
								</Button>
							)}
							{this.state.value === 'signIn' && (
								<Button
									className="cardActionsBtn"
									raised
									disabled={this.state.signing}
									color="primary"
									onClick={() => {
										this.validate('signIn');
									}}
								>
									{this.state.signing ? 'Signing In' : 'Sign In'}
								</Button>
							)}
							{this.state.value === 'signIn' && (
								<Typography
									className="cardActionsBtn forgot"
									onClick={() => {
										this.setState({ value: 'help' });
									}}
								>
									Forgot?
								</Typography>
							)}
							{this.state.value === 'help' && (
								<Button
									className="cardActionsBtn"
									raised
									disabled={this.state.signing}
									color="primary"
									onClick={() => {
										this.validate('help');
									}}
								>
									Reset
								</Button>
							)}
							{this.state.value === 'help' && this.renderSignInWithEmailBtn()}
							)}
						</CardActions>
					</Card>
				</Fade>
				<Snack
					snackStatus={this.state.snackStatus}
					snackMessage={this.state.snackMessage}
					closeSnack={() => {
						this.closeSnack();
					}}
				/>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/JoinCard.js